import { jsx as _jsx } from "react/jsx-runtime";
import { injectIntl } from 'react-intl';
import { Styled } from './tooltip.style';
const ToolTipWithIntl = ({ id, intl, onClick, children }) => {
    const name = intl.formatMessage({ id, defaultMessage: '' });
    return (_jsx(Styled.ToolTip, { onClick: onClick, title: name, "aria-label": name, role: "tooltip", children: children }));
};
export const ToolTip = injectIntl(ToolTipWithIntl);
//# sourceMappingURL=tooltip.js.map